var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 7.58333C2.3335 6.939 2.85583 6.41667 3.50016 6.41667H10.5002C11.1445 6.41667 11.6668 6.939 11.6668 7.58333V11.0833C11.6668 11.7277 11.1445 12.25 10.5002 12.25H3.50016C2.85583 12.25 2.3335 11.7277 2.3335 11.0833V7.58333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 4.08333C4.66683 2.79467 5.7115 1.75 7.00016 1.75C8.28883 1.75 9.3335 2.79467 9.3335 4.08333V6.41667H4.66683V4.08333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 8.75V9.91667M3.50016 12.25H10.5002C11.1445 12.25 11.6668 11.7277 11.6668 11.0833V7.58333C11.6668 6.939 11.1445 6.41667 10.5002 6.41667H3.50016C2.85583 6.41667 2.3335 6.939 2.3335 7.58333V11.0833C2.3335 11.7277 2.85583 12.25 3.50016 12.25ZM9.3335 6.41667V4.08333C9.3335 2.79467 8.28883 1.75 7.00016 1.75C5.7115 1.75 4.66683 2.79467 4.66683 4.08333V6.41667H9.3335Z",
    stroke: "#374151",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lockClosed.82a2f6a9c7ba26c7ac5dbd29659f4538.svg";
export { ForwardRef as ReactComponent };